import { Injectable } from '@angular/core';
import { CurrencyLocaleData, getCurrencyLocaleDataByCountryCode } from '@pedix-workspace/utils';

@Injectable()
export class CurrencyFormatService {
  get currencyLocaleData(): CurrencyLocaleData {
    return getCurrencyLocaleDataByCountryCode();
  }
}
